import React from 'react';
import { observer } from 'mobx-react';
import { Flex, Icon, Text } from 'core/components';
import FormGroupIndicator from 'core/form/components/FormGroupIndicator';
import AssetTagInventoryCollection from 'app/stores/assetTags/AssetTagInventoryCollection';

interface Props {
  form: {
    getMatchingFields: (fieldName: string) => unknown[];
  };
  tab: {
    id: string;
    fields: string[];
    icon?: string;
    title: React.ReactNode;
  };
  assetTagsCollection?: AssetTagInventoryCollection | null;
}

function TabTitle({ form, tab, assetTagsCollection }: Props) {
  return (
    <Flex alignItems="center" gap="6px">
      {(assetTagsCollection?.errorCount ?? 0) > 0 && tab.id === 'assetTags' && <Icon icon="error" color="danger" />}
      <FormGroupIndicator form={form} fields={tab.fields} icon={tab.icon} />
      <Text>{tab.title}</Text>
    </Flex>
  );
}

export default observer(TabTitle);
